import { WarningIcon } from '@chakra-ui/icons';
import { chakra } from '@chakra-ui/react';
import React from 'react';

import {
  CmTable,
  CmTableBodyRow,
  CmTableHeader,
  CmTbody,
  CmTd,
  CmTh,
  CmTooltip,
} from '@/components/uiParts';
import { ManagerAccount } from '@/domain/models/AuthEnterprise';

import { MemberDetailModal } from './MemberDetailModal';

interface Props {
  memberAccounts: ManagerAccount[];
}

const CustomTh = chakra(CmTh, {
  baseStyle: {
    textAlign: 'center',
    borderColor: 'gray.300',
    bgColor: 'transparent',
  },
});

const CustomTd = chakra(CmTd, {
  baseStyle: {
    textAlign: 'center',
    borderColor: 'gray.300',
  },
});

export const MembersTable: React.VFC<Props> = ({ memberAccounts }) => {
  return (
    <CmTable>
      <CmTableHeader>
        <CustomTh borderBottom="1px" borderBottomColor="gray.300">
          名前
        </CustomTh>
        <CustomTh>メールアドレス</CustomTh>
        <CustomTh>権限</CustomTh>
        <CustomTh>担当店舗</CustomTh>
      </CmTableHeader>
      <CmTbody>
        {memberAccounts.map((account, i) => (
          <CmTableBodyRow key={i}>
            <CustomTd>
              {account.name}
              {!account.has_registered && (
                <CmTooltip
                  label="招待中です"
                  aria-label="招待中です"
                  placement="right"
                >
                  <WarningIcon color="yellow.500" ml={2} />
                </CmTooltip>
              )}
            </CustomTd>
            <CustomTd>{account.email}</CustomTd>
            <CustomTd>{account.role_type}</CustomTd>
            <CustomTd minW="5rem">
              {account.role_type === '店舗責任者' &&
              account.store_names !== undefined &&
              account.store_names.length > 0 ? (
                <MemberDetailModal
                  accountName={account.name}
                  storeNames={account.store_names}
                />
              ) : (
                '-'
              )}
            </CustomTd>
          </CmTableBodyRow>
        ))}
      </CmTbody>
    </CmTable>
  );
};
